module.exports = __webpack_public_path__ + "img/BNP Paribas .266224b2.png";